import { JetView } from 'webix-jet';
import { devConfig, menus } from 'config/config';

/**
 * Class representing a table menu view.
 * @extends JetView
 */
export default class tableMenuView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        let dataMenus = []; // Array to hold menu data

        // Event listener for 'dataMenus' event to update dataMenus
        this.on(this.app, 'dataMenus', (data) => {
            dataMenus = data;
        });

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'treetable', // Treetable view for displaying hierarchical data
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            scheme: {
                                $group: {
                                    by: 'FatherMenu', // Grouping by FatherMenu
                                    map: {
                                        FatherMenu: ['FatherMenu'],
                                        Url: ['Url'],
                                    },
                                },
                            },
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                { id: 'Id', header: '', hidden: true }, // Hidden column for Id
                                {
                                    id: 'FatherMenu',
                                    header: _('Menú Padre'), // Header with localization
                                    width: 350,
                                    editor: 'combo', // Combo editor for this column
                                    options: menus, // Options for the combo editor
                                    template: function (obj, common) {
                                        if (obj.$group) {
                                            var value = '';
                                            if (dataMenus.length > 0) {
                                                value = dataMenus.filter(
                                                    (item) => item.FatherMenu === obj.FatherMenu,
                                                )[0].FatherDescription; // Get description for grouped items
                                                return common.treetable(obj, common) + value;
                                            }
                                        } else {
                                            if (dataMenus.length > 0) {
                                                return obj.FatherDescription; // Return description for non-grouped items
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'rating',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        if (obj.$level == 2) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Icon for editing
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Url',
                                    header: 'Url', // Header for URL column
                                    width: 350,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Description',
                                    header: _('Descripción'), // Header with localization
                                    width: 450,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Order',
                                    header: _('Orden'), // Header with localization
                                    width: 80,
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead setting
                            datafetch: devConfig.getDefaultDataFetch(), // Data fetch configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'UserManagement/GetAllMenus'; // API URL for fetching menus
        const vthis = this; // Reference to the current instance
        var optionsMenusFather = []; // Array to hold father menu options
        var popupAdd; // Popup for adding a new menu
        var popupEdit; // Popup for editing a menu
        var filter = ''; // Filter string for API requests

        // Event listener for 'menu:filter' to apply filters to the grid
        this.on(this.app, 'menu:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to hold query parameters

            // Build query parameters based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            filter = string1; // Update filter variable
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=1000' + string1).then(function (response) {
                var resp = response.json(); // Parse JSON response
                var data = []; // Array to hold parsed data
                try {
                    resp.Data.forEach(function (menu) {
                        if (menu.data.length > 0) {
                            menu.data.forEach(function (submenu) {
                                if (!menu.notMenu) {
                                    var obj = {
                                        Id: submenu.id,
                                        FatherMenu: menu.id,
                                        Url: submenu.page,
                                        Description: submenu.description,
                                        FatherDescription: menu.description,
                                        Order: submenu.order,
                                    };
                                    data.push(obj); // Push parsed submenu data
                                }
                            });
                        }
                    });
                } catch (e) {
                    console.log(e); // Log any errors
                }
                vthis.app.callEvent('dataMenus', [data]); // Trigger dataMenus event with new data
                setTimeout(() => {
                    grid.clearAll(); // Clear grid data
                    grid.parse(data); // Parse new data into grid
                }, 10);
            });
        });

        // Load father menus on webix ready
        webix.ready(function () {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'UserManagement/GetFatherMenus', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message(_('Error! ')); // Show error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text); // Parse JSON response
                        if (!data.HasError) {
                            var dataoptions = []; // Array for father menu options
                            try {
                                data.Data.forEach(function (option) {
                                    if (option.show) {
                                        dataoptions.push(option); // Push visible options
                                    }
                                });
                            } catch (e) {
                                console.log(e); // Log any errors
                            }
                            $$('FatherMenuF').define(
                                'options',
                                dataoptions, // Define options for FatherMenuF
                            );
                            $$('FatherMenuF').refresh(); // Refresh the FatherMenuF
                            grid.refreshColumns(); // Refresh grid columns
                            let options = $$('datatable').config.columns.filter((item) => item.id === 'FatherMenu')[0]
                                .collection; // Get collection for FatherMenu column
                            options.clearAll(); // Clear existing options
                            options.parse(dataoptions); // Parse new options
                            optionsMenusFather = dataoptions; // Update father menu options
                            popupAdd = webix.ui({
                                view: 'window', // Popup for adding a new menu
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Crear Menú'), // Label for creating menu
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide(); // Close popup
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the popup
                                modal: true, // Make the popup modal
                                body: {
                                    view: 'form',
                                    id: 'createMenuForm', // ID for the create menu form
                                    elements: [
                                        {
                                            margin: 10,
                                            rows: [
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Url'), // Label for URL input
                                                    name: 'Url',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Descripción'), // Label for description input
                                                    name: 'Description',
                                                    required: true, // Required field
                                                },
                                                {
                                                    view: 'combo',
                                                    labelPosition: 'top',
                                                    label: _('Menú Padre'), // Label for father menu combo
                                                    name: 'FatherMenu',
                                                    options: optionsMenusFather, // Options for father menu
                                                    required: false, // Not required
                                                },
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Orden'), // Label for order input
                                                    name: 'Order',
                                                    type: 'number', // Number input
                                                    required: false, // Not required
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'), // Cancel button
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close popup
                                                        $$('createMenuForm').setValues(
                                                            $$('createMenuForm').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    type: 'form',
                                                    value: _('Guardar'), // Save button
                                                    click: function ($e) {
                                                        var values = $$('createMenuForm').getValues(); // Get form values
                                                        if (
                                                            $$('createMenuForm').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'UserManagement/CreateMenu',
                                                                    values, // Send form values to API
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message('Error! '); // Show error message
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(text); // Parse response
                                                                            if (text.HasError) {
                                                                                webix.message(
                                                                                    'Error: ' + text.AlertMessage, // Show error message if any
                                                                                );
                                                                            } else {
                                                                                webix.message(
                                                                                    'Menú creado satisfactoriamente', // Success message
                                                                                );
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=1000' +
                                                                                        filter, // Reload grid data
                                                                                ).then(function (response) {
                                                                                    var resp = response.json(); // Parse JSON response
                                                                                    var data = []; // Array to hold parsed data
                                                                                    resp.Data.forEach(function (menu) {
                                                                                        menu.data.forEach(
                                                                                            function (submenu) {
                                                                                                var obj = {
                                                                                                    Id: submenu.id,
                                                                                                    FatherMenu: menu.id,
                                                                                                    Url: submenu.page,
                                                                                                    Description:
                                                                                                        submenu.description,
                                                                                                    FatherDescription:
                                                                                                        menu.description,
                                                                                                    Order: submenu.order,
                                                                                                };
                                                                                                data.push(
                                                                                                    obj, // Push parsed submenu data
                                                                                                );
                                                                                            },
                                                                                        );
                                                                                    });
                                                                                    vthis.app.callEvent('dataMenus', [
                                                                                        data,
                                                                                    ]); // Trigger dataMenus event with new data
                                                                                    setTimeout(() => {
                                                                                        grid.clearAll(); // Clear grid data
                                                                                        grid.parse(
                                                                                            data, // Parse new data into grid
                                                                                        );
                                                                                    }, 10);
                                                                                    vthis.getTopParentView().hide(); // Close popup
                                                                                    $$('createMenuForm').setValues(
                                                                                        $$(
                                                                                            'createMenuForm',
                                                                                        ).getCleanValues(), // Reset form values
                                                                                    );
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Close popup
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Show validation error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    elementsConfig: {
                                        on: {
                                            onChange: function () {
                                                this.validate(); // Validate form on change
                                            },
                                        },
                                    },
                                },
                            });
                            popupEdit = webix.ui({
                                view: 'window', // Popup for editing a menu
                                id: 'editMenu',
                                fullscreen: screen.width < 500 ? true : false, // Fullscreen on small screens
                                head: {
                                    view: 'toolbar',
                                    cols: [
                                        {
                                            view: 'label',
                                            label: _('Editar Menú'), // Label for editing menu
                                        },
                                        {
                                            view: 'icon',
                                            icon: 'wxi-close',
                                            click: function () {
                                                this.getTopParentView().hide(); // Close popup
                                            },
                                        },
                                    ],
                                },
                                position: 'center', // Center the popup
                                modal: true, // Make the popup modal
                                body: {
                                    view: 'form',
                                    id: 'editform', // ID for the edit form
                                    elements: [
                                        {
                                            margin: 10,
                                            rows: [
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Id'), // Label for ID input
                                                    name: 'Id',
                                                    hidden: true, // Hidden field
                                                },
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Url'), // Label for URL input
                                                    name: 'Url',
                                                    readonly: false, // Editable field
                                                },
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Descripción'), // Label for description input
                                                    name: 'Description',
                                                    readonly: false, // Editable field
                                                },
                                                {
                                                    view: 'combo',
                                                    labelPosition: 'top',
                                                    label: _('Menú Padre'), // Label for father menu combo
                                                    name: 'FatherMenu',
                                                    options: optionsMenusFather, // Options for father menu
                                                    readonly: false, // Editable field
                                                },
                                                {
                                                    view: 'text',
                                                    labelPosition: 'top',
                                                    label: _('Orden'), // Label for order input
                                                    name: 'Order',
                                                    type: 'number', // Number input
                                                    readonly: false, // Editable field
                                                },
                                            ],
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button',
                                                    value: _('Cancelar'), // Cancel button
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Close popup
                                                        $$('editform').setValues(
                                                            $$('editform').getCleanValues(), // Reset form values
                                                        );
                                                    },
                                                },
                                                {
                                                    view: 'button',
                                                    type: 'form',
                                                    value: _('Guardar'), // Save button
                                                    click: function ($e) {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        if (
                                                            $$('editform').validate() // Validate form
                                                        ) {
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json',
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() + 'UserManagement/EditMenu',
                                                                    {
                                                                        Id: values.Id,
                                                                        Url: values.Url,
                                                                        Description: values.Description,
                                                                        FatherMenu: values.FatherMenu,
                                                                        Order: values.Order,
                                                                    },
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message('Error! '); // Show error message
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(text); // Parse response
                                                                            if (text.HasError) {
                                                                                webix.message(
                                                                                    'Error: ' + text.AlertMessage, // Show error message if any
                                                                                );
                                                                            } else {
                                                                                webix.message(
                                                                                    'Menú editado satisfactoriamente', // Success message
                                                                                );
                                                                                grid.load(
                                                                                    url +
                                                                                        '?start=0&count=1000' +
                                                                                        filter, // Reload grid data
                                                                                ).then(function (response) {
                                                                                    var resp = response.json(); // Parse JSON response
                                                                                    var data = []; // Array to hold parsed data
                                                                                    resp.Data.forEach(function (menu) {
                                                                                        menu.data.forEach(
                                                                                            function (submenu) {
                                                                                                var obj = {
                                                                                                    Id: submenu.id,
                                                                                                    FatherMenu: menu.id,
                                                                                                    Url: submenu.page,
                                                                                                    Description:
                                                                                                        submenu.description,
                                                                                                    FatherDescription:
                                                                                                        menu.description,
                                                                                                    Order: submenu.order,
                                                                                                };
                                                                                                data.push(
                                                                                                    obj, // Push parsed submenu data
                                                                                                );
                                                                                            },
                                                                                        );
                                                                                    });
                                                                                    vthis.app.callEvent('dataMenus', [
                                                                                        data,
                                                                                    ]); // Trigger dataMenus event with new data
                                                                                    setTimeout(() => {
                                                                                        grid.clearAll(); // Clear grid data
                                                                                        grid.parse(
                                                                                            data, // Parse new data into grid
                                                                                        );
                                                                                    }, 10);
                                                                                    this.getTopParentView().hide(); // Close popup
                                                                                    $$('editform').setValues(
                                                                                        $$('editform').getCleanValues(), // Reset form values
                                                                                    );
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Close popup
                                                        } else {
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Completa los campos...', // Show validation error message
                                                                ),
                                                            });
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                },
                            });
                            $$('editform').bind($$('datatable')); // Bind edit form to datatable
                        }
                    },
                });
        });

        // Event listener for creating a new menu
        this.on(this.app, 'createMenu:button', (filter) => {
            if (optionsMenusFather.length > 0) {
                popupAdd.show(); // Show add menu popup
                $$('createMenuForm').clearValidation(); // Clear validation
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if data not loaded
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Event listener for opening the edit menu popup
        this.on(this.app, 'openEdit', (item) => {
            if (optionsMenusFather.length > 0) {
                popupEdit.show(); // Show edit menu popup
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message if data not loaded
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
